var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"flat":""}},[_c('span',{staticClass:"toolbar-title"},[_vm._v("Tickets")]),_c('v-spacer'),_c('TicketMapNavButtons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }